import TableOfContents from './tableOfContents';

const tableOfContentsConfig = {
  name: 'tableOfContents',
  class: TableOfContents,
  querySelectorAll: {
    target: '.table-of-contents__item',
  },
};

export default tableOfContentsConfig;
